// @file Enums

// Mirrors AccessibilitySettingPreference in the Rails app. Duplicated here so
// this package has no dependency on consumer enums.
enum ReducedMotionPreference {
  SYSTEM = 'system',
  ON = 'on',
  OFF = 'off',
}

enum EditorVariant {
  PHONE = 'phone',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
  DESKTOP_DOCKED = 'desktop_docked',
}

enum AttachmentPickerState {
  IDLE = 'idle',
  LOADING = 'loading',
  DRAGGING = 'dragging',
}

// Must match app/javascript/bits/content_picker.ts#ContentPickerSource
enum ContentPickerSource {
  FileBrowser = 'file',
  LinkInput = 'link',
  WebBrowser = 'web_search',
  PhotoBooth = 'photo_booth',
  VideoRecorder = 'video_recorder',
  AudioRecorder = 'audio_recorder',
  DrawingCanvas = 'drawing',
  PadletBrowser = 'padlet',
  MapBrowser = 'location_search',
  ScreenshareRecorder = 'screen_recorder',
  AiImageSearch = 'ai_image_search',
  ImageSearch = 'image_search',
  VideoSearch = 'video_search',
  AudioSearch = 'audio_search',
  GifSearch = 'gif_search',
  Poll = 'poll',
  GoogleDrive = 'google_drive',
  MicrosoftOneDrive = 'microsoft_one_drive_picker',
  AiTalk = 'ai_talk',
  MediaLibrary = 'media_library',
  PhotoAlbum = 'photo_album',
  DeviceUploads = 'device_uploads',
}

export { AttachmentPickerState, ContentPickerSource, EditorVariant, ReducedMotionPreference }
